import React, { useState } from 'react';
import { Select, Tabs, message, AutoComplete, Collapse } from 'antd';
import { DeleteOutlined, PlusOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';

const EducationInfo = ({ educationData, languageData, computerSkillsData, setEducationData, setLanguageData, setComputerSkillsData, selectors, changedData, setChangedData, allowedEdit }) => {

    const [showEducationModal, setShowEducationModal] = useState(false);
    const [editEducation, setEditEducation] = useState(false);
    const [editEducationIndex, setEditEducationIndex] = useState(-1);
    const [newEducationData, setNewEducationData] =  useState({
        Start: '',
        End: '',
        EducationType: {
            Name: '',
            UID: ''
        },
        EducationKind: {
            Name: '',
            UID: ''
        },
        Institution: {
            Name: '',
            UID: ''
        },
        Faculty: '',
        Speciality: {
            Name: '',
            UID: ''
        },
        DocTypeEducation: {
            Name: '',
            UID: ''
        },
        DocSeries: '',
        DocNumber: '',
        DocDateIssued: '',
        RowKey: ''
    });
    const [showLanguageModal, setShowLanguageModal] = useState(false);
    const [editLanguage, setEditLanguage] = useState(false);
    const [editLanguageIndex, setEditLanguageIndex] = useState(-1);
    const [newLanguageData, setNewLanguageData] = useState({
        Language: {
            Name: '',
            UID: ''
        },
        LanguageDegree: {
            Name: '',
            UID: ''
        },
        RowKey: ''
    });
    const [showComputerSkillsModal, setShowComputerSkillsModal] = useState(false);
    const [editComputerSkill, setEditComputerSkill] = useState(false);
    const [editComputerSkillIndex, setEditComputerSkillIndex] = useState(0);
    const [newComputerSkillData, setNewComputerSkillData] = useState({
        Software: {
            Name: '',
            UID: ''
        },
        SoftwareLevel: {
            Name: '',
            UID: ''
        },
        RowKey: ''
    });

    const updateChangedData = (key, data) => {
        setChangedData(prevState => ({
            ...prevState,
            [key]: data
        }));
    };
    
    const handleEducationChange = (e, option) => {
        let { name, value, dataset } = typeof e === "string" ? option : e.target;
        const { parent } = dataset;
        if(name === 'Start' || name === 'End' || name === 'DocDateIssued') value += 'T00:00:00';
        if(parent) {
            if(dataset.uid) {
                setNewEducationData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value,
                        UID: dataset.uid
                    }
                }));
            } else {
                setNewEducationData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value
                    }
                }));
            }
        } else{            
            setNewEducationData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }        
    };

    const handleInstitutionChange = (value) => {
        let parent = 'Institution';
        setNewEducationData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleSpecialityChange = (value) => {
        let parent = 'Speciality';
        setNewEducationData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleEducationTypeChange = (value) => {
        let parent = 'EducationType';
        setNewEducationData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleAddEducationRow = (e) => {
        e.preventDefault();
        if (Date.parse(newEducationData.Start) > Date.parse(newEducationData.End)) {
            message.warning('Дата начала обучения не может быть больше даты окончания обучения!');
        } else if (Date.parse(newEducationData.Start) > Date.now()) {
            message.warning('Дата начала обучения не может быть больше текущей даты!');
        } else if (newEducationData.Start.length === "") {
            message.warning('Выберите дату начала образования!');
        } else if (newEducationData.End.length === "") {
            message.warning('Выберите дату окончания образования!');
        } else if (newEducationData.EducationType.Name.length === 0) {
            message.warning('Выберите вид образования!');
        } else if (newEducationData.Institution.Name.length === 0) {
            message.warning('Выберите учебное заведение!');
        } else if (newEducationData.Speciality.Name.length === 0) {
            message.warning('Выберите специальность!');
        } else if (newEducationData.DocTypeEducation.Name.length === 0) {
            message.warning('Выберите вид документа!');
        } else if (newEducationData.DocSeries.length === 0) {
            message.warning('Заполните серию документа!');
        } else if (newEducationData.DocNumber.length === 0) {
            message.warning('Заполните номер документа!');
        } else if (newEducationData.DocDateIssued.length === 0) {
            message.warning('Выберите дату выдачи документа!');
        } else {
            if(editEducation) {
                setEducationData(prevData => {
                    const newData = [...prevData];
                    newData[editEducationIndex] = newEducationData;
                    // updateChangedData('Education', newData); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все образования
                    return newData;
                });     
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    if (!updatedChangedData.hasOwnProperty('Education')) {
                        updatedChangedData.Education = [newEducationData];
                    } else {
                        if (newEducationData.RowKey === "") {
                            const index = updatedChangedData.Education.findIndex(edu => edu.id === newEducationData.id);
                            if (index !== -1) {
                                updatedChangedData.Education[index] = newEducationData;
                            } else {
                                updatedChangedData.Education.push(newEducationData);
                            }
                        } else {
                            const index = updatedChangedData.Education.findIndex(edu => edu.RowKey === newEducationData.RowKey);
                            if (index !== -1) {
                                updatedChangedData.Education[index] = newEducationData;
                            } else {
                                updatedChangedData.Education.push(newEducationData);
                            }
                        }
                    }                  
                    return updatedChangedData;
                });       
            } else {
                newEducationData.Deletable = true;
                newEducationData.id = Date.now();
                setEducationData(prevData => {
                    if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
                        // updateChangedData('Education', [newEducationData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все образования
                        return [newEducationData];
                    } else {
                        // updateChangedData('Education', [...prevData, newEducationData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все образования
                        return [...prevData, newEducationData];
                    }
                });  
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    if (!updatedChangedData.hasOwnProperty('Education')) {
                        updatedChangedData.Education = [newEducationData];
                    } else {
                        updatedChangedData.Education.push(newEducationData);
                    }
                  
                    return updatedChangedData;
                });  
            }
            setShowEducationModal(false);
            setNewEducationData({
                Start: '',
                End: '',
                EducationType: {
                    Name: '',
                    UID: ''
                },
                EducationKind: {
                    Name: '',
                    UID: ''
                },
                Institution: {
                    Name: '',
                    UID: ''
                },
                Faculty: '',
                Speciality: {
                    Name: '',
                    UID: ''
                },
                DocTypeEducation: {
                    Name: '',
                    UID: ''
                },
                DocSeries: '',
                DocNumber: '',
                DocDateIssued: '',
                RowKey: ''
            });
            setEditEducation(false);
            setEditEducationIndex(-1);
        }
    };
    
    const handleCloseEducationModal = () => {
        setShowEducationModal(false);
        setNewEducationData({
            Start: '',
            End: '',
            EducationType: {
                Name: '',
                UID: ''
            },
            EducationKind: {
                Name: '',
                UID: ''
            },
            Institution: {
                Name: '',
                UID: ''
            },
            Faculty: '',
            Speciality: {
                Name: '',
                UID: ''
            },
            DocTypeEducation: {
                Name: '',
                UID: ''
            },
            DocSeries: '',
            DocNumber: '',
            DocDateIssued: '',
			RowKey: ''
        });
        setEditEducation(false);
        setEditEducationIndex(-1);
    };
    
    const handleRemoveEducationRow = (index) => {
        setEducationData(prevData => {
            const newData = [...prevData];
            if(newData[index].RowKey.length > 0) {
                newData[index].delete = true;
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    if (!updatedChangedData.hasOwnProperty('Education')) {
                        updatedChangedData.Education = [newData[index]];
                    } else {
                        const i = updatedChangedData.Education.findIndex(edu => edu.RowKey === newData[index].RowKey);
                        if (i !== -1) {
                            updatedChangedData.Education[i].delete = true;
                        } else {
                            updatedChangedData.Education.push(newData[index]);
                        }
                    }                  
                    return updatedChangedData;
                });
            }
            else {
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    const i = updatedChangedData.Education.findIndex(edu => edu.id === newData[index].id);
                    if (i !== -1) {
                        updatedChangedData.Education.splice(i, 1);
                    }                
                    return updatedChangedData;
                });
                newData.splice(index, 1);
            }
            // updateChangedData('Education', newData);
            return newData;
        });
    };    
    
    const handleLanguageChange = (e, option) => {
        const { name, value, dataset } = typeof e === "string" ? option : e.target;
        const { parent } = dataset;
        if (parent) {
            if(dataset.uid) {
                setNewLanguageData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value,
                        UID: dataset.uid
                    }
                }));
            } else {
                setNewLanguageData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value
                    }
                }));
            }
        } else {
            setNewLanguageData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleLanguageNameChange = (value) => {
        let parent = 'Language';
        setNewLanguageData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleAddLanguageRow = (e) => {
        e.preventDefault();
        const isLanguageExists = languageData.some(languageObj => languageObj.Language.Name === newLanguageData.Language.Name);
        if (newLanguageData.Language.Name.length === 0) {
            message.warning('Выберите язык!');
        } else if (newLanguageData.LanguageDegree.Name.length === 0) {
            message.warning('Выберите степень владения языком!');
        } else if (isLanguageExists && !editLanguage) {
            message.warning('Выбранный язык уже есть в списке языков, которыми вы владеете!');
        } else {
            if (editLanguage) {
                for(let i = 0; i < languageData.length; i++) {
                    if(newLanguageData.Language.Name === languageData[i].Language.Name && editLanguageIndex !== i) {
                        message.warning('Выбранный язык уже есть в списке языков, которыми вы владеете!');
                        return null;
                    }
                }
                setLanguageData(prevData => {
                    const newData = [...prevData];
                    newData[editLanguageIndex] = newLanguageData;
                    // updateChangedData('Languages', newData); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все языки
                    return newData;
                });
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    if (!updatedChangedData.hasOwnProperty('Languages')) {
                        updatedChangedData.Languages = [newLanguageData];
                    } else {
                        if (newLanguageData.RowKey === "") {
                            const index = updatedChangedData.Languages.findIndex(lang => lang.id === newLanguageData.id);
                            if (index !== -1) {
                                updatedChangedData.Languages[index] = newLanguageData;
                            } else {
                                updatedChangedData.Languages.push(newLanguageData);
                            }
                        } else {
                            const index = updatedChangedData.Languages.findIndex(lang => lang.RowKey === newLanguageData.RowKey);
                            if (index !== -1) {
                                updatedChangedData.Languages[index] = newLanguageData;
                            } else {
                                updatedChangedData.Languages.push(newLanguageData);
                            }
                        }
                    }
                  
                    return updatedChangedData;
                });
            } else {
                newLanguageData.Deletable = true;
                newLanguageData.id = Date.now();
                setLanguageData(prevData => {
                    if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
                        // updateChangedData('Languages', [newLanguageData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все языки
                        return [newLanguageData];
                    } else {
                        // updateChangedData('Languages', [...prevData, newLanguageData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все языки
                        return [...prevData, newLanguageData];
                    }
                }); 
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    if (!updatedChangedData.hasOwnProperty('Languages')) {
                        updatedChangedData.Languages = [newLanguageData];
                    } else {
                        updatedChangedData.Languages.push(newLanguageData);
                    }
                  
                    return updatedChangedData;
                });
            }
            setShowLanguageModal(false);
            setNewLanguageData({
                Language: {
                    Name: '',
                    UID: ''
                },
                LanguageDegree: {
                    Name: '',
                    UID: ''
                },
                RowKey: ''
            });
            setEditLanguage(false);
            setEditLanguageIndex(-1);
        }
    };
    
    const handleCloseLanguageModal = () => {
        setShowLanguageModal(false);
        setNewLanguageData({
            Language: {
                Name: '',
                UID: ''
            },
            LanguageDegree: {
                Name: '',
                UID: ''
            },
			RowKey: ''
        });
        setEditLanguage(false);
        setEditLanguageIndex(-1);
    };
    
    const handleRemoveLanguageRow = (index) => {
        setLanguageData(prevData => {
            const newData = [...prevData];
            if(newData[index].RowKey.length > 0) {
                newData[index].delete = true;
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    if (!updatedChangedData.hasOwnProperty('Languages')) {
                        updatedChangedData.Languages = [newData[index]];
                    } else {
                        const i = updatedChangedData.Languages.findIndex(lang => lang.RowKey === newData[index].RowKey);
                        if (i !== -1) {
                            updatedChangedData.Languages[i].delete = true;
                        } else {
                            updatedChangedData.Languages.push(newData[index]);
                        }
                    }
                  
                    return updatedChangedData;
                });
            }
            else {
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    const i = updatedChangedData.Languages.findIndex(lang => lang.id === newData[index].id);
                    if (i !== -1) {
                        updatedChangedData.Languages.splice(i, 1);
                    }                
                    return updatedChangedData;
                });
                newData.splice(index, 1);
            }
            // updateChangedData('Languages', newData);
            return newData;
        });
    };

    const handleComputerSkillsChange = (e, option) => {
        const { name, value, dataset } = typeof e === "string" ? option : e.target;
        const { parent } = dataset;
        if (parent) {
            if(dataset.uid) {
                setNewComputerSkillData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value,
                        UID: dataset.uid
                    }
                }));
            } else {
                setNewComputerSkillData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value
                    }
                }));
            }
        } else {
            setNewComputerSkillData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleComputerSkillNameChange = (value) => {
        let parent = 'Software';
        setNewComputerSkillData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleAddComputerSkillRow = (e) => {
        e.preventDefault();
        const isSoftwareExists = computerSkillsData.some(compObj => compObj.Software.Name === newComputerSkillData.Software.Name);
        if (newComputerSkillData.Software.Name.length === 0) {
            message.warning('Выберите програмнное обеспечение!');
        } else if (newComputerSkillData.SoftwareLevel.Name.length === 0) {
            message.warning('Выберите уровень владения програмнным обеспечением!');
        } else if (isSoftwareExists && !editComputerSkill) {
            message.warning('Выбранное программное обеспечение уже есть в списке ПО, которыми вы владеете!');
        } else {
            if (editComputerSkill) {
                for(let i = 0; i < computerSkillsData.length; i++) {
                    if(newComputerSkillData.Software.Name === computerSkillsData[i].Software.Name && editComputerSkillIndex !== i) {
                        message.warning('Выбранное программное обеспечение уже есть в списке ПО, которыми вы владеете!');
                        return null;
                    }
                }
                setComputerSkillsData(prevData => {
                    const newData = [...prevData];
                    newData[editComputerSkillIndex] = newComputerSkillData;
                    // updateChangedData('ComputerSkills', newData); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все навыки
                    return newData;
                });
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    if (!updatedChangedData.hasOwnProperty('ComputerSkills')) {
                        updatedChangedData.ComputerSkills = [newComputerSkillData];
                    } else {
                        if (newComputerSkillData.RowKey === "") {
                            const index = updatedChangedData.ComputerSkills.findIndex(comp => comp.id === newComputerSkillData.id);
                            if (index !== -1) {
                                updatedChangedData.ComputerSkills[index] = newComputerSkillData;
                            } else {
                                updatedChangedData.ComputerSkills.push(newComputerSkillData);
                            }
                        } else {
                            const index = updatedChangedData.ComputerSkills.findIndex(comp => comp.RowKey === newComputerSkillData.RowKey);
                            if (index !== -1) {
                                updatedChangedData.ComputerSkills[index] = newComputerSkillData;
                            } else {
                                updatedChangedData.ComputerSkills.push(newComputerSkillData);
                            }
                        }
                    }                  
                    return updatedChangedData;
                });
            } else {
                newComputerSkillData.Deletable = true;
                newComputerSkillData.id = Date.now();
                setComputerSkillsData(prevData => {
                    if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
                        // updateChangedData('ComputerSkills', [newComputerSkillData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все навыки
                        return [newComputerSkillData];
                    } else {
                        // updateChangedData('ComputerSkills', [...prevData, newComputerSkillData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все навыки
                        return [...prevData, newComputerSkillData];
                    }
                });
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    if (!updatedChangedData.hasOwnProperty('ComputerSkills')) {
                        updatedChangedData.ComputerSkills = [newComputerSkillData];
                    } else {
                        updatedChangedData.ComputerSkills.push(newComputerSkillData);
                    }
                  
                    return updatedChangedData;
                });
            }
            setShowComputerSkillsModal(false);
            setNewComputerSkillData({
                Software: {
                    Name: '',
                    UID: ''
                },
                SoftwareLevel: {
                    Name: '',
                    UID: ''
                },
                RowKey: ''
            });
            setEditComputerSkill(false);
            setEditComputerSkillIndex(-1);
        }
    };
    
    const handleCloseComputerSkillModal = () => {
        setShowComputerSkillsModal(false);
        setNewComputerSkillData({
            Software: {
                Name: '',
                UID: ''
            },
            SoftwareLevel: {
                Name: '',
                UID: ''
            },
			RowKey: ''
        });
        setEditComputerSkill(false);
        setEditComputerSkillIndex(-1);
    };
    
    const handleRemoveComputerSkillRow = (index) => {
        setComputerSkillsData(prevData => {
            const newData = [...prevData];
            if(newData[index].RowKey.length > 0) {
                newData[index].delete = true;
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    if (!updatedChangedData.hasOwnProperty('ComputerSkills')) {
                        updatedChangedData.ComputerSkills = [newData[index]];
                    } else {
                        const i = updatedChangedData.ComputerSkills.findIndex(comp => comp.RowKey === newData[index].RowKey);
                        if (i !== -1) {
                            updatedChangedData.ComputerSkills[i].delete = true;
                        } else {
                            updatedChangedData.ComputerSkills.push(newData[index]);
                        }
                    }                  
                    return updatedChangedData;
                });
            }
            else {
                setChangedData(prevState => {
                    const updatedChangedData = { ...prevState };
                    const i = updatedChangedData.ComputerSkills.findIndex(comp => comp.id === newData[index].id);
                    if (i !== -1) {
                        updatedChangedData.ComputerSkills.splice(i, 1);
                    }                
                    return updatedChangedData;
                });
                newData.splice(index, 1);
            }
            // updateChangedData('ComputerSkills', newData);
            return newData;
        });
    };

    const isObjectEmpty = (data) => {
        for (const item of data) {
            for (const key in item) {
                if (typeof item[key] === 'object') {
                    const subItem = item[key];
                    for (const subKey in subItem) {
                        if (subItem[subKey] !== '') {
                            return false;
                        }
                    }
                } else if (item[key] !== '') {
                    return false;
                }
            }
        }
        return true;
    };

    const items = [
        {
            key: '1',
            label: 'Образование',
            children: <>
                    <div className='profile-content education-info-content'>
                        {allowedEdit && <button type='button' className='addButton' onClick={() => setShowEducationModal(true)}><PlusOutlined /> Добавить образование</button> }
                        {!isObjectEmpty(educationData) && educationData.map((edu, index) => edu.delete !== true && (
                            <div className={'itemCard'}>
                                <h1>{edu.EducationType.Name ? edu.EducationType.Name : 'Не указано'}</h1>
                                <p>{edu.Institution.Name ? edu.Institution.Name : 'Не указано'}</p>
                                {allowedEdit && <div className={'actions'}>
                                    <button className="btn" onClick={() => {
                                        setNewEducationData(edu);
                                        setEditEducation(true);
                                        setEditEducationIndex(index);
                                        setShowEducationModal(true);
                                    }}><EditOutlined /></button>
                                    <button className="btn" onClick={() => handleRemoveEducationRow(index)}><DeleteOutlined /></button>
                                </div>}
                            </div>                                        
                        ))}
                        {showEducationModal && (
                            <>
                            <div className="modal-bg" onClick={() => handleCloseEducationModal()}></div>
                            <div className="modal">
                            <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Образование</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseEducationModal()} ><CloseOutlined /></button>
                            <table style={{ width: '100%' }}>
                                <tbody> 
                                    <tr>
                                        <td width='40%'><p className='title'>Период</p></td>
                                        <td width='60%'>
                                            С<input
                                                type="date"
                                                name="Start"
                                                value={newEducationData.Start ? newEducationData.Start.split('T')[0] : ''}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                            по<input
                                                type="date"
                                                name="End"
                                                value={newEducationData.End ? newEducationData.End.split('T')[0] : ''}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                        </td>
                                    </tr> 
                                    <tr>
                                        <td><p className='title'>Вид обучения</p></td>
                                        <td>
                                            <Select
                                                size='small'
                                                value={newEducationData.EducationKind.Name ? newEducationData.EducationKind.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                style={{ width: '100%' }}
                                                placeholder="Выберите вид обучения"
                                                options={selectors.educationKinds}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Название ВУЗа (ССУ)</p></td>
                                        <td>
                                            {/* <Select
                                                size='small'
                                                showSearch
                                                value={newEducationData.Institution.Name ? newEducationData.Institution.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                style={{ width: '100%' }}
                                                placeholder="Выберите ВУЗ (ССУ)"
                                                optionFilterProp="children"
                                                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                                                notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                options={selectors.institutions}
                                            /> */}
                                            <AutoComplete
                                                allowClear={true}
                                                size='medium'
                                                options={selectors.institutions}
                                                style={{
                                                    width: '100%',
                                                }}
                                                value={newEducationData.Institution.Name}
                                                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                onSelect={(e, option) => handleEducationChange(e, option)}
                                                onChange={handleInstitutionChange}
                                                placeholder="Название ВУЗа (ССУ)"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Факультет</p></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="Faculty"
                                                value={newEducationData.Faculty}
                                                placeholder='Факультет'
                                                onChange={(e) => handleEducationChange(e)}
                                                style={{ marginLeft: '0', width: '100%' }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Специальность</p></td>
                                        <td>
                                            {/* <Select
                                                size='small'
                                                style={{ width: '100%' }}
                                                showSearch
                                                notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                value={newEducationData.Speciality.Name ? newEducationData.Speciality.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                placeholder="Специальность"
                                                options={selectors.specialties}
                                            /> */}
                                            <AutoComplete
                                                allowClear={true}
                                                options={selectors.specialties}
                                                style={{
                                                    width: '100%',
                                                }}
                                                value={newEducationData.Speciality.Name}
                                                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                onSelect={(e, option) => handleEducationChange(e, option)}
                                                onChange={handleSpecialityChange}
                                                placeholder="Специальность"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Вид образования</p></td>
                                        <td>
                                            {/* <Select
                                                size='small'
                                                style={{ width: '100%' }}
                                                showSearch
                                                notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                value={newEducationData.EducationType.Name ? newEducationData.EducationType.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                placeholder="Выберите вид образоваия"
                                                options={selectors.educationTypes}
                                            /> */}
                                            <AutoComplete
                                                allowClear={true}
                                                options={selectors.educationTypes}
                                                style={{
                                                    width: '100%',
                                                }}
                                                value={newEducationData.EducationType.Name}
                                                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                onSelect={(e, option) => handleEducationChange(e, option)}
                                                onChange={handleEducationTypeChange}
                                                placeholder="Выберите вид образоваия"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Вид документа</p></td>
                                        <td>
                                            <Select
                                                size='small'
                                                value={newEducationData.DocTypeEducation.Name ? newEducationData.DocTypeEducation.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                style={{ width: '100%' }}
                                                placeholder="Выберите вид документа"
                                                options={selectors.docTypesEducation}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Серия документа</p></td>
                                        <td>
                                            <input
                                                style={{ margin: '7px 0 0 5px' }}
                                                width="40%"
                                                type="text"
                                                name="DocSeries"
                                                placeholder='Серия'
                                                value={newEducationData.DocSeries}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Номер документа</p></td>
                                        <td>
                                            <input
                                                style={{ margin: '7px 0 0 5px' }}
                                                width="40%"
                                                type="number"
                                                name="DocNumber"
                                                placeholder='Номер'
                                                value={newEducationData.DocNumber}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Дата выдачи</p></td>
                                        <td>
                                            <input
                                                style={{ margin: '7px 0 0 5px' }}
                                                width="40%"
                                                type="date"
                                                name="DocDateIssued"
                                                value={newEducationData.DocDateIssued ? newEducationData.DocDateIssued.split('T')[0] : ''}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ marginTop: "32px" }}></div>
                            <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddEducationRow(e)}>ОК</button>
                            </div>
                            </>
                        )}
                    </div>
                </>,
        },
        {
            key: '2',
            label: 'Знание языков',
            children: <>
                <div className='profile-content education-info-content'>
                    {allowedEdit && <button type='button' className='addButton' onClick={() => setShowLanguageModal(true)}><PlusOutlined /> Добавить язык</button>}
                    {!isObjectEmpty(languageData) && languageData.map((lang, index) => lang.delete !== true  && (
                        <div className={'itemCard'}>
                            <h1>{lang.Language.Name ? lang.Language.Name : 'Не указано'}</h1>
                            <p>{lang.LanguageDegree.Name ? lang.LanguageDegree.Name : 'Не указано'}</p>
                            {allowedEdit && <div className={'actions'}>
                                <button className="btn" onClick={() => {
                                    setNewLanguageData(lang);
                                    setEditLanguage(true);
                                    setEditLanguageIndex(index);
                                    setShowLanguageModal(true);
                                }}><EditOutlined /></button>
                                <button className="btn" onClick={() => handleRemoveLanguageRow(index)}><DeleteOutlined /></button>
                            </div>}
                        </div>  
                    ))}
                    {showLanguageModal && (
                        <>
                            <div className="modal-bg" onClick={() => handleCloseLanguageModal()}></div>
                            <div className="modal">
                                <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Язык</h4>
                                <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseLanguageModal()} ><CloseOutlined /></button>
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td width='40%'><p className='title'>Язык</p></td>
                                            <td width='60%'>
                                                {/* <Select
                                                    size='small'
                                                    showSearch
                                                    notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                    value={newLanguageData.Language.Name ? newLanguageData.Language.Name : undefined}
                                                    onChange={(e, option) => handleLanguageChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите язык"
                                                    options={selectors.languages}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    size='medium'
                                                    options={selectors.languages}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newLanguageData.Language.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleLanguageChange(e, option)}
                                                    onChange={handleLanguageNameChange}
                                                    placeholder="Выберите язык"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Степень владения</p></td>
                                            <td>
                                                <Select
                                                    size='small'
                                                    value={newLanguageData.LanguageDegree.Name ? newLanguageData.LanguageDegree.Name : undefined}
                                                    onChange={(e, option) => handleLanguageChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Уровень владения"
                                                    options={selectors.languageDegrees}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={{ marginTop: "32px" }}></div>
                                <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddLanguageRow(e)}>ОК</button>
                            </div>
                        </>
                    )}
                </div>
            </>,
        },
        {
            key: '3',
            label: 'Компьютерная грамотность',
            children: <>
                <div className='profile-content education-info-content'>
                    {allowedEdit && <button type='button' className='addButton' onClick={() => setShowComputerSkillsModal(true)}><PlusOutlined /> Добавить программное обеспечение</button>}
                    {!isObjectEmpty(computerSkillsData) && computerSkillsData.map((comp, index) => comp.delete !== true && (
                        <div className={'itemCard'}>
                            <h1>{comp.Software.Name ? comp.Software.Name : 'Не указано'}</h1>
                            <p>{comp.SoftwareLevel.Name ? comp.SoftwareLevel.Name : 'Не указано'}</p>
                            {allowedEdit && <div className={'actions'}>
                                <button className="btn" onClick={() => {
                                    setNewComputerSkillData(comp);
                                    setEditComputerSkill(true);
                                    setEditComputerSkillIndex(index);
                                    setShowComputerSkillsModal(true);
                                }}><EditOutlined /></button>
                                <button className="btn" onClick={() => handleRemoveComputerSkillRow(index)}><DeleteOutlined /></button>
                            </div>}
                        </div> 
                    ))}
                    {showComputerSkillsModal && (
                        <>
                            <div className="modal-bg" onClick={() => handleCloseComputerSkillModal()}></div>
                            <div className="modal">
                                <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Компьютерные навыки</h4>
                                <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseComputerSkillModal()} ><CloseOutlined /></button>
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td width='40%'><p className='title'>Программное обеспечение</p></td>
                                            <td width='60%'>
                                                {/* <Select
                                                    size='small'
                                                    value={newComputerSkillData.Software.Name ? newComputerSkillData.Software.Name : undefined}
                                                    onChange={handleComputerSkillsChange}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите ПО"
                                                    options={selectors.softwares}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    size='medium'
                                                    options={selectors.softwares}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newComputerSkillData.Software.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleComputerSkillsChange(e, option)}
                                                    onChange={handleComputerSkillNameChange}
                                                    placeholder="Выберите ПО"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Уровень владения</p></td>
                                            <td>
                                                <Select
                                                    size='small'
                                                    value={newComputerSkillData.SoftwareLevel.Name ? newComputerSkillData.SoftwareLevel.Name : undefined}
                                                    onChange={handleComputerSkillsChange}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите уровень владения"
                                                    options={selectors.softwareLevels}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={{ marginTop: "32px" }}></div>
                                <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddComputerSkillRow(e)}>ОК</button>
                            </div>
                        </>
                    )}
                </div>
            </>,
        },
    ];


    return (
        <>
        <div style={{ background: '#fff' }}>
        <Tabs
            defaultActiveKey="1"
            tabPosition='left'
            size="small"
            className='educationTabs'
            items={[
                {
                    label: 'Образование',
                    key: 1,
                    children: <>
                        <div className='profile-content education-info-content'>
                            {allowedEdit && <button type='button' className='addButton' onClick={() => setShowEducationModal(true)}><PlusOutlined /> Добавить образование</button> }
                            {!isObjectEmpty(educationData) && educationData.map((edu, index) => edu.delete !== true && (
                                <div className={'itemCard'}>
                                    <h1>{edu.EducationType.Name ? edu.EducationType.Name : 'Не указано'}</h1>
                                    <p>{edu.Institution.Name ? edu.Institution.Name : 'Не указано'}</p>
                                    {allowedEdit && <div className={'actions'}>
                                        <button className="btn" onClick={() => {
                                            setNewEducationData(edu);
                                            setEditEducation(true);
                                            setEditEducationIndex(index);
                                            setShowEducationModal(true);
                                        }}><EditOutlined /></button>
                                        <button className="btn" onClick={() => handleRemoveEducationRow(index)}><DeleteOutlined /></button>
                                    </div>}
                                </div>   
                            ))}
                            {showEducationModal && (
                                <>
                                <div className="modal-bg" onClick={() => handleCloseEducationModal()}></div>
                                <div className="modal">
                                <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Образование</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseEducationModal()} ><CloseOutlined /></button>
                                <table>
                                    <tbody> 
                                        <tr>
                                            <td width='40%'><p className='title'>Период</p></td>
                                            <td width='60%'>
                                                С<input
                                                    type="date"
                                                    name="Start"
                                                    value={newEducationData.Start ? newEducationData.Start.split('T')[0] : ''}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                                по<input
                                                    type="date"
                                                    name="End"
                                                    value={newEducationData.End ? newEducationData.End.split('T')[0] : ''}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                            </td>
                                        </tr> 
                                        <tr>
                                            <td><p className='title'>Вид обучения</p></td>
                                            <td>
                                                <Select
                                                    size='small'
                                                    value={newEducationData.EducationKind.Name ? newEducationData.EducationKind.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите вид обучения"
                                                    options={selectors.educationKinds}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Название ВУЗа (ССУ)</p></td>
                                            <td>
                                                {/* <Select
                                                    size='small'
                                                    showSearch
                                                    value={newEducationData.Institution.Name ? newEducationData.Institution.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите ВУЗ (ССУ)"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                                                    notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                    options={selectors.institutions}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    size='medium'
                                                    options={selectors.institutions}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newEducationData.Institution.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleEducationChange(e, option)}
                                                    onChange={handleInstitutionChange}
                                                    placeholder="Название ВУЗа (ССУ)"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Факультет</p></td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name="Faculty"
                                                    value={newEducationData.Faculty}
                                                    placeholder='Факультет'
                                                    onChange={(e) => handleEducationChange(e)}
                                                    style={{ marginLeft: '0', width: '100%' }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Специальность</p></td>
                                            <td>
                                                {/* <Select
                                                    size='small'
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                    notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                    value={newEducationData.Speciality.Name ? newEducationData.Speciality.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    placeholder="Специальность"
                                                    options={selectors.specialties}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    options={selectors.specialties}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newEducationData.Speciality.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleEducationChange(e, option)}
                                                    onChange={handleSpecialityChange}
                                                    placeholder="Специальность"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Вид образования</p></td>
                                            <td>
                                                {/* <Select
                                                    size='small'
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                    notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                    value={newEducationData.EducationType.Name ? newEducationData.EducationType.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    placeholder="Выберите вид образоваия"
                                                    options={selectors.educationTypes}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    options={selectors.educationTypes}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newEducationData.EducationType.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleEducationChange(e, option)}
                                                    onChange={handleEducationTypeChange}
                                                    placeholder="Выберите вид образоваия"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Вид документа</p></td>
                                            <td>
                                                <Select
                                                    size='small'
                                                    value={newEducationData.DocTypeEducation.Name ? newEducationData.DocTypeEducation.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите вид документа"
                                                    options={selectors.docTypesEducation}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Серия документа</p></td>
                                            <td>
                                                <input
                                                    style={{ margin: '7px 0 0 5px' }}
                                                    width="40%"
                                                    type="text"
                                                    name="DocSeries"
                                                    placeholder='Серия'
                                                    value={newEducationData.DocSeries}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Номер документа</p></td>
                                            <td>
                                                <input
                                                    style={{ margin: '7px 0 0 5px' }}
                                                    width="40%"
                                                    type="text"
                                                    name="DocNumber"
                                                    placeholder='Номер'
                                                    value={newEducationData.DocNumber}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Дата выдачи</p></td>
                                            <td>
                                                <input
                                                    style={{ margin: '7px 0 0 5px' }}
                                                    width="40%"
                                                    type="date"
                                                    name="DocDateIssued"
                                                    value={newEducationData.DocDateIssued ? newEducationData.DocDateIssued.split('T')[0] : ''}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={{ marginTop: "32px" }}></div>
                                <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddEducationRow(e)}>ОК</button>
                                </div>
                                </>
                            )}
                        </div>
                    </>,
                },
                {
                    label: 'Знание языков',
                    key: 2,
                    children: <>
                        <div className='profile-content education-info-content'>
                            {allowedEdit && <button type='button' className='addButton' onClick={() => setShowLanguageModal(true)}><PlusOutlined /> Добавить язык</button>}
                            {!isObjectEmpty(languageData) && languageData.map((lang, index) => lang.delete !== true  && (
                                <div className={'itemCard'}>
                                    <h1>{lang.Language.Name ? lang.Language.Name : 'Не указано'}</h1>
                                    <p>{lang.LanguageDegree.Name ? lang.LanguageDegree.Name : 'Не указано'}</p>
                                    {allowedEdit && <div className={'actions'}>
                                        <button className="btn" onClick={() => {
                                            setNewLanguageData(lang);
                                            setEditLanguage(true);
                                            setEditLanguageIndex(index);
                                            setShowLanguageModal(true);
                                        }}><EditOutlined /></button>
                                        <button className="btn" onClick={() => handleRemoveLanguageRow(index)}><DeleteOutlined /></button>
                                    </div> }
                                </div>  
                            ))}
                            {showLanguageModal && (
                                <>
                                    <div className="modal-bg" onClick={() => handleCloseLanguageModal()}></div>
                                    <div className="modal">
                                        <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Язык</h4>
                                        <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseLanguageModal()} ><CloseOutlined /></button>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width='40%'><p className='title'>Язык</p></td>
                                                    <td width='60%'>
                                                        {/* <Select
                                                            size='small'
                                                            showSearch
                                                            notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                            value={newLanguageData.Language.Name ? newLanguageData.Language.Name : undefined}
                                                            onChange={(e, option) => handleLanguageChange(e, option)}
                                                            style={{ width: '100%' }}
                                                            placeholder="Выберите язык"
                                                            options={selectors.languages}
                                                        /> */}
                                                        <AutoComplete
                                                            allowClear={true}
                                                            size='medium'
                                                            options={selectors.languages}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            value={newLanguageData.Language.Name}
                                                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                            onSelect={(e, option) => handleLanguageChange(e, option)}
                                                            onChange={handleLanguageNameChange}
                                                            placeholder="Выберите язык"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><p className='title'>Степень владения</p></td>
                                                    <td>
                                                        <Select
                                                            size='small'
                                                            value={newLanguageData.LanguageDegree.Name ? newLanguageData.LanguageDegree.Name : undefined}
                                                            onChange={(e, option) => handleLanguageChange(e, option)}
                                                            style={{ width: '100%' }}
                                                            placeholder="Уровень владения"
                                                            options={selectors.languageDegrees}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div style={{ marginTop: "32px" }}></div>
                                        <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddLanguageRow(e)}>ОК</button>
                                    </div>
                                </>
                            )}
                        </div>
                    </>,
                },
                {
                    label: 'Компьютерная грамотность',
                    key: 3,
                    children: <>
                        <div className='profile-content education-info-content'>
                            {allowedEdit && <button type='button' className='addButton' onClick={() => setShowComputerSkillsModal(true)}><PlusOutlined /> Добавить программное обеспечение</button>}
                            {!isObjectEmpty(computerSkillsData) && computerSkillsData.map((comp, index) => comp.delete !== true && (
                                <div className={'itemCard'}>
                                    <h1>{comp.Software.Name ? comp.Software.Name : 'Не указано'}</h1>
                                    <p>{comp.SoftwareLevel.Name ? comp.SoftwareLevel.Name : 'Не указано'}</p>
                                    {allowedEdit && <div className={'actions'}>
                                        <button className="btn" onClick={() => {
                                            setNewComputerSkillData(comp);
                                            setEditComputerSkill(true);
                                            setEditComputerSkillIndex(index);
                                            setShowComputerSkillsModal(true);
                                        }}><EditOutlined /></button>
                                        <button className="btn" onClick={() => handleRemoveComputerSkillRow(index)}><DeleteOutlined /></button>
                                    </div>}
                                </div> 
                            ))}
                            {showComputerSkillsModal && (
                                <>
                                    <div className="modal-bg" onClick={() => handleCloseComputerSkillModal()}></div>
                                    <div className="modal">
                                        <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Компьютерные навыки</h4>
                                        <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseComputerSkillModal()} ><CloseOutlined /></button>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width='40%'><p className='title'>Программное обеспечение</p></td>
                                                    <td width='60%'>
                                                        {/* <Select
                                                            size='small'
                                                            value={newComputerSkillData.Software.Name ? newComputerSkillData.Software.Name : undefined}
                                                            onChange={handleComputerSkillsChange}
                                                            style={{ width: '100%' }}
                                                            placeholder="Выберите ПО"
                                                            options={selectors.softwares}
                                                        /> */}
                                                        <AutoComplete
                                                            allowClear={true}
                                                            size='medium'
                                                            options={selectors.softwares}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            value={newComputerSkillData.Software.Name}
                                                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                            onSelect={(e, option) => handleComputerSkillsChange(e, option)}
                                                            onChange={handleComputerSkillNameChange}
                                                            placeholder="Выберите ПО"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><p className='title'>Уровень владения</p></td>
                                                    <td>
                                                        <Select
                                                            size='small'
                                                            value={newComputerSkillData.SoftwareLevel.Name ? newComputerSkillData.SoftwareLevel.Name : undefined}
                                                            onChange={handleComputerSkillsChange}
                                                            style={{ width: '100%' }}
                                                            placeholder="Выберите уровень владения"
                                                            options={selectors.softwareLevels}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div style={{ marginTop: "32px" }}></div>
                                        <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddComputerSkillRow(e)}>ОК</button>
                                    </div>
                                </>
                            )}
                        </div>
                    </>,
                }
            ]}
        />  
        <Collapse items={items} accordion defaultActiveKey={['1']} className='educationCollaps'/>
        </div>      
        </>
    );
};

export default EducationInfo;
